import React, { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Navbar from "./components/NavigationBar/Navbar";
import ContactFormDialog from "./components/InquaryDialog/InquaryDialog";
import SuccessDialog from "./components/SuccessDialog/SuccessDialog";
// import { Button } from "@mui/material";
import { Box } from "@mui/material";
import Footer from "./components/Footer/Footer2";
import AppRoutes from "./routes/AppRoutes";

export const useFormState = () => {
  const [open, setIsOpen] = React.useState(false);
  return [open, setIsOpen];
};

const App = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);

  return (
    <div>
      <Router>
        {/* The site shell owns shared UI; page selection is kept in AppRoutes. */}
        <ContactFormDialog
          isFormOpen={isFormOpen}
          setIsFormOpen={setIsFormOpen}
          onSuccess={setSuccessMessage}
        />
        <SuccessDialog
          open={Boolean(successMessage)}
          title={successMessage?.title}
          message={successMessage?.message}
          onClose={() => setSuccessMessage(null)}
        />
        <Navbar setIsFormOpen={setIsFormOpen} />
        <div>
          <AppRoutes
            setIsFormOpen={setIsFormOpen}
            onSuccess={setSuccessMessage}
          />
          <Box>
            <Footer setIsFormOpen={setIsFormOpen} />
          </Box>
        </div>
      </Router>
    </div>
  );
};

export default App;
